import UploadImage from '@/components/upload-image/index.vue';
import { mapGetters } from 'vuex';
import TransactionProService from '../transaction-pro-service';
import ProjectService from '../../person-center/project/project.service';
import Service from '@/service/index.js';
import { errorMessage, successMessage } from '@/utils/message.js';
import TransLandInfo from '../transaction-list-detail/trans-land-info/trans-land-info.vue';
import SelectBank from '@/components/select-bank/index.vue';
const debounce = require('lodash.debounce');

export default {
  components: {
    UploadImage,
    TransLandInfo,
    SelectBank
  },
  data() {
    return {
      projectName: '',
      projectId: '',
      otherPurposeCheck: false, // 用途是其他的时候展示
      ruleForm: {
        economicMemberName: '',
        remark: '',
        files: [],
        assetsBidInfos: [], // 的标传参
        economicMemberType: '', // 身份
        isEnjoyPriority: '',
        purposeList: [],
        bankId: ''
      },
      bidInfos: {},
      projectTypeList: [],
      identityList: [],
      projectInfo: [],
      priorityStatus: [
        {code: true, value: '是'},
        {code: false, value: '否'}
      ],
      // 必填校验
      rules: {
        selectPurpose: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        economicMemberType: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        isEnjoyPriority: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        bankId: [
          { required: true, message: '请选择银行账号', trigger: 'blur' }
        ]
      },
      purpose: '', // 其他的受让用途信息
      contractorPriority: [], // 优先权人返回集合
      bidGeneralSituationList: [], // 标的概况
      gridData: [{
        date: '10以下',
        name: '2'
      }, {
        date: '10（不含）～100',
        name: '1.5'
      }, {
        date: '100（不含）～1000',
        name: '1'
      }, {
        date: '1000（不含）以上',
        name: '0.5'
      }],
      bidSignRelationId: ''
    };
  },
  computed: {
    ...mapGetters([
      'loginUserType',
      'assetsBidInfos',
      'userInfo'
    ])
  },
  created () {
    this.id = this.$route.query.id;
    this.bidSignRelationId = this.$route.query.bidSignRelationId;
    this.bidSignRelationId && this.getBidInfos();
    if (this.id) {
      this.getTransProjectDetail();
    }
    // 上传图片 获取文件
    Service.getSelectList('SIGN_PEOPLE_BID_FILE_TYPE').then(res => {
      if (res && res.code === '0') {
        const arr = [];
        // 受让资格材料证明
        res.data.forEach(item => {
          if(item.code === '6'){
            item.code = 10;
            arr[0] = item;
          }
          console.log(this.userInfo.type, 'userInfo.type');
          if(Number(this.userInfo.type) === 2) { // 法人的授权委托书
            if(item.code === '1'){
              item.code = 14;
              arr[1] = item;

              // 耕地下的农户耕地和农户承包地
              if(this.projectInfo && this.projectInfo.projectType === 1) {
                arr[1]['value'] = '法人单位的授权委托书';
              }
            }
            if(item.code === '3'){ // 其他材料
              item.code = 11;
              arr[2] = item;
            }
          } else {
            if(item.code === '3'){
              item.code = 11;
              arr[1] = item;
            }
          }
          // if(item.code === '6') arr[0] = item;
          // if(item.code === '1') arr[1] = item;
          // if(item.code === '3') arr[2] = item;
          return arr;
        });
        // console.log(arr);
        this.initFile(arr);
      }
    });
    // 受让用途 选择身份获取枚举val
    const obj = {
      TRANSFEREE_PURPOSE: 'projectTypeList',
      BID_GENERAL_SITUATION: 'bidGeneralSituationList'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  mounted() {
    // this.id = this.$route.query.id;
    // if (this.id) {
    //   this.getTransProjectDetail();
    // }
    console.log(this.assetsBidInfos, 'assetsBidInfos的val');
  },
  methods: {
    // 获取标的信息
    getBidInfos () {
      TransactionProService.getRollOutProjectDetail({
        projectId: this.id,
        echoCode: 'BID'
      }).then(res => {
        this.bidInfos = res?.data?.detail;
        // 从撤销报名过来
        this.$store.commit('UPDATE_TRANSACTION_INFO', this.bidInfos);
      });
    },
    getIdentityList () {
      let type = 'ECONOMIC_MEMBER_TYPE';
      console.log(this.projectInfo && this.projectInfo.projectType === 1 && this.projectInfo.projectSubType === 2);
      if (this.projectInfo && this.projectInfo.projectType === 1 && this.projectInfo.projectSubType === 2) {
        type = 'ECONOMIC_MEMBER_TYPE_1_2';
      }
      console.log(type, 'type');
      Service.getSelectList(type).then(res => {
        if (res && res.code === '0') {
          let list = [];
          this.contractorPriority.forEach(item => {
            list.push(item);
          });
          this.identityList = res.data.filter(item => list.indexOf(item.code) > -1);
        }
      });
    },
    // 文件接口 转化
    initFile (arr) {
      arr.forEach(item => {
        this.ruleForm.files.push({
          projectFileType: Number(item.code),
          title: item.value,
          filePaths: [],
          inputValue: null,
          defaultImage: []
        });
      });
    },
    // 跳转授权委托书样例
    downTemplate() {
      window.open('/授权委托书样例（法人机构用户）.pdf');
    },
    // 对图片做必填校验的判断
    fileRules (item) {
      let required = true;
      if (item.projectFileType === 11) {
        required = false;
      }
      return {
        required: required,
        message: '请上传' + item.title,
        trigger: 'change'
      };
    },
    // 选择受让用途的时候
    selectChanged(row) {
      this.ruleForm.selectPurpose = row.value;
      if(row.code === '8') {
        this.otherPurposeCheck = true;
      } else {
        this.otherPurposeCheck = false;
      }
    },
    // // 下拉选择框的点击
    // handle() {
    //   console.log(this.ruleForm.purpose);
    // },
    // 优先权选择
    handle() {
      if(this.ruleForm.isEnjoyPriority === false){
        this.ruleForm.economicMemberType = '';
      }
    },
    // 获取交易详情
    getTransProjectDetail() {
      TransactionProService.getTransProjectDetail({
        projectId: this.id,
        echoCode: 'PROJECT'
      }).then(res => {
        if (res && res.code === '0') {
          // 综合类处理受让用途
          if(Number(res.data.projectType === 8)) {
            let assetsInfo = res.data.assetsInfo && JSON.parse(res.data.assetsInfo);
            assetsInfo.forEach(item => {
              if(Number(item.bidGeneralSituation) !== 7) {
                this.ruleForm.purposeList.push(
                  {
                    'bidGeneralSituation': item.bidGeneralSituation,
                    'content': ''
                  }
                );
              }
            });
          }
          this.projectName = res && res.data && res.data.projectName;
          this.projectInfo = res.data;
          this.contractorPriority = res.data.contractorPriorityCode;
          this.getIdentityList();

          if(res.data.transferType === 2){
            let that = this;
            that.assetsBidInfos.forEach(item => {
              // this.bindid获取到地块里面的标的id 追加进数组ruleForm.assetsBidInfos里 传给后台 拆分
              this.ruleForm.assetsBidInfos.push({
                projectBidId: item.bidId
              });
            });
          } else {
            let that = this;
            that.assetsBidInfos.forEach((item, index) => {
              // this.bindid获取到地块里面的标的id 追加进数组ruleForm.assetsBidInfos里 传给后台 整体
              if(index === 0) {
                this.ruleForm.assetsBidInfos.push({
                  projectBidId: item.bidId
                });
              }
            });
          }
          this.bidSignRelationId && this.getSignUpProjectDetail();
        }
      });
    },
    // 获取撤销报名详情
    getSignUpProjectDetail() {
      ProjectService.getSignUpProjectDetail(this.bidSignRelationId).then(res => {
        if (res && res.code === '0') {
          let {
            purpose: selectPurpose,
            economicType: economicMemberType,
            economicName: economicMemberName,
            enjoyPriority: isEnjoyPriority,
            bankId,
            remark
          } = res.data;

          this.ruleForm = {
            ...this.ruleForm,
            economicMemberName,
            selectPurpose,
            isEnjoyPriority,
            bankId,
            remark
          };
          if (economicMemberType) {
            this.ruleForm.economicMemberType = String(economicMemberType);
          }
          console.log(this.ruleForm, '====this.ruleForm');
          if (this.projectInfo.projectType === 1) {
            this.ruleForm.selectPurpose = '';
          }
          if (this.projectInfo.projectType === 8) {
            this.ruleForm.purposeList = JSON.parse(selectPurpose);
          }
          this.showImages(res.data.assignment, 10); // 受让资格证明材料
          this.showImages(res.data.authorization, 14); // 授权委托书
          this.showImages(res.data.other, 11); // 其他
        }
      });
    },
    // 上传图片
    uploadImage (index, event) {
      this.ruleForm.files[index].filePaths = event;
      if (event.length) {
        this.ruleForm.files[index].inputValue = event.length;
      } else {
        this.ruleForm.files[index].inputValue = null;
      }
    },
    // 图片回显处理
    showImages (fileList = [], projectFileType) {
      let ruleFormFiles = Array.from(this.ruleForm.files);
      const index = ruleFormFiles.findIndex(file => file.projectFileType === projectFileType);
      if (index >= 0) {
        fileList?.forEach(image => {
          ruleFormFiles[index].defaultImage.push({
            url: image.allPath,
            ossImgUrl: image.allPath,
            sourceImgUrl: image.fullPath
          });
          ruleFormFiles[index].filePaths.push({
            ossImgUrl: image.allPath,
            sourceImgUrl: image.fullPath
          });
          ruleFormFiles[index].inputValue = fileList.length;
        });
      }
    },
    // 返回
    previousStep () {
      this.$router.back();
    },
    // 立即提交
    test: debounce(function() {
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交报名信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    }, 2000, {
      'leading': true,
      'trailing': false
    }),
    // 确认提交按钮
    submit() {
      const files = [];
      // 标的信息 =》标的id和受用信息
      this.ruleForm.assetsBidInfos.forEach(item => {
        // 综合类
        if(this.projectInfo && this.projectInfo.projectType === 8) {
          item.purpose = JSON.stringify(this.ruleForm.purposeList);
        } else {
          if(this.otherPurposeCheck === true) {
            item.purpose = this.purpose;
          } else {
            item.purpose = this.ruleForm.selectPurpose;
          }
        }
        item.depositAmount = this.projectInfo && this.projectInfo.sumMargin;
      });
      // 文件传参
      this.ruleForm.files.forEach(item => {
        const filePaths = [];
        item.filePaths.forEach(obj => {
          filePaths.push(obj.sourceImgUrl);
        });
        files.push({
          imgEnumType: item.projectFileType,
          urls: [...filePaths]
        });
      });
      if(this.otherPurposeCheck === true) {
        this.ruleForm.purpose = this.purpose;
      } else {
        this.ruleForm.purpose = this.ruleForm.selectPurpose;
      }
      // 保存接口传参
      TransactionProService.atonceSign({
        ...this.ruleForm,
        files: files,
        projectId: this.id
      }).then(res => {
        if (res && res.code === '0') {
          successMessage('已经报名成功');
          this.$router.push('/person-center/project/sign-up-project/list');
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('报名失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('报名失败');
        }
      });
    }
  }
};
